export const SAGA_GET_LOCALIDADES_ENTREGA_ACTIVAS = 'LocalidadEntregaReducer/SAGA_GET_LOCALIDADES_ENTREGA_ACTIVAS';
export const SET_LOCALIDADES_ENTREGA = 'LocalidadEntregaReducer/SET_LOCALIDADES_ENTREGA';
export const SAGA_GET_LOCALIDAD_ENTREGA = 'LocalidadEntregaReducer/SAGA_GET_LOCALIDAD_ENTREGA';
export const SET_LOCALIDAD_ENTREGA = 'LocalidadEntregaReducer/SET_LOCALIDAD_ENTREGA';

export const sagaGetLocalidadesEntregaActivas = () => ({
    type: SAGA_GET_LOCALIDADES_ENTREGA_ACTIVAS,
})

export const setLocalidadesEntrega = (payload) => ({
    type: SET_LOCALIDADES_ENTREGA,
    payload,
})

export const sagaGetLocalidadEntrega = (idLocalidadEntrega) => ({
    type: SAGA_GET_LOCALIDAD_ENTREGA,
    idLocalidadEntrega,
})

export const setLocalidadEntrega = (payload) => ({
    type: SET_LOCALIDAD_ENTREGA,
    payload,
})

